import EmptyImage from '../../../assets/images/empty.svg?react'
import { CSSProperties, PropsWithChildren } from 'react'

interface IProps {
  inscription: string
  style?: CSSProperties
}

const EmptyPlaceholder = (props: PropsWithChildren<IProps>) => {
  return (
    <div className="flex-lines gap8 center" style={props.style}>
      <EmptyImage />
      <p className="text-nm text-description text-center" style={{ whiteSpace: 'pre-wrap' }}>
        {props.inscription}
      </p>
      {props.children}
    </div>
  )
}

export default EmptyPlaceholder
